import auth from "./Registrarse/firebase";

/*
 * Dominio de tu VPS.
 * REACT_APP_API_URL permite cambiarlo desde .env.
 */
const apiOrigin = (
  process.env.REACT_APP_API_URL ||
  "https://tmoxnight.shop"
).replace(/\/+$/, "");

export const apiUrl = (path) => {
  const normalizedPath = path.startsWith("/")
    ? path
    : `/${path}`;

  return `${apiOrigin}/api${normalizedPath}`;
};

export async function adminRequest(
  path,
  options = {}
) {
  const user = auth.currentUser;

  if (!user) {
    throw new Error(
      "Inicia sesión antes de continuar."
    );
  }

  const token = await user.getIdToken();

  const headers = new Headers(
    options.headers || {}
  );

  headers.set(
    "Authorization",
    `Bearer ${token}`
  );

  if (
    options.body &&
    !(options.body instanceof FormData)
  ) {
    headers.set(
      "Content-Type",
      "application/json"
    );
  }

  let response;

  try {
    response = await fetch(apiUrl(path), {
      ...options,
      headers
    });
  } catch (error) {
    throw new Error(
      "No se pudo conectar con el VPS."
    );
  }

  const body = await response
    .json()
    .catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      body.error ||
        `El servidor rechazó la solicitud (${response.status}).`
    );
  }

  return body;
}

export async function uploadWithProgress(
  path,
  formData,
  onProgress
) {
  const user = auth.currentUser;

  if (!user) {
    throw new Error(
      "Inicia sesión antes de continuar."
    );
  }

  const token = await user.getIdToken();

  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();

    request.open(
      "POST",
      apiUrl(path)
    );

    request.setRequestHeader(
      "Authorization",
      `Bearer ${token}`
    );

    request.responseType = "json";
    request.timeout = 10 * 60 * 1000;

    request.upload.addEventListener(
      "progress",
      (event) => {
        if (event.lengthComputable) {
          const percentage = Math.round(
            (event.loaded / event.total) * 100
          );

          onProgress?.(percentage);
        }
      }
    );

    request.addEventListener("load", () => {
      const body = request.response || {};

      if (
        request.status >= 200 &&
        request.status < 300
      ) {
        resolve(body);
        return;
      }

      reject(
        new Error(
          body.error ||
            `El servidor rechazó la carga (${request.status}).`
        )
      );
    });

    request.addEventListener(
      "timeout",
      () => {
        reject(
          new Error(
            "La carga tardó demasiado y fue cancelada."
          )
        );
      }
    );

    request.addEventListener(
      "error",
      () => {
        reject(
          new Error(
            "No se pudo conectar con el VPS."
          )
        );
      }
    );

    request.addEventListener(
      "abort",
      () => {
        reject(
          new Error(
            "La carga fue cancelada."
          )
        );
      }
    );

    request.send(formData);
  });
}

export async function loadServerChapter(
  mangaId,
  chapterId,
  signal
) {
  let response;

  try {
    response = await fetch(
      apiUrl(
        `/reader/${encodeURIComponent(
          mangaId
        )}/${encodeURIComponent(chapterId)}`
      ),
      { signal }
    );
  } catch (error) {
    if (error.name === "AbortError") {
      throw error;
    }

    throw new Error(
      "No se pudo conectar con el VPS."
    );
  }

  const body = await response
    .json()
    .catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      body.error ||
        "No se pudo abrir el capítulo."
    );
  }

  return body;
}